import { IntersectionTests, Plane } from "cesium";
import { EarthBrainUtils } from "./earthbrainutility";
export class EarthBrainPlane {
    _plane;
    constructor(point, normal) {
        this._plane = Plane.fromPointNormal(point, normal);
    }
    rayCast(ray) {
        if (!EarthBrainUtils.isValidRay(ray)) {
            console.warn("Invalid ray");
            return undefined;
        }
        return IntersectionTests.rayPlane(ray, this._plane);
    }
}
//# sourceMappingURL=earthbrain-plane.js.map